<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>
    
    <div v-else>

        <div class="container-title">
            <b-container>

                <b-row>

                    <b-col cols="10" class="p-0-30">

                        <b-row class="title-audit-text">
                            {{entity.AuditName}}                                             
                        </b-row>

                        <b-row class="m-0 row-title">
                            <font-awesome-icon icon="store-alt" class="mr-10"/>
                            {{entity.Name}}
                        </b-row>

                        <b-row v-if="entity.TradePoint" class="m-0 row-title">
                            <font-awesome-icon icon="map-marker-alt" class="mr-10"/>
                            {{entity.TradePoint.Address}}
                        </b-row>

                    </b-col>

                    <b-col class="p-0">

                        <b-row class="pointer h-end m-0 fs-17">

                            <div v-if="entity.TradePoint" class="wrapper-circle-icon" @click="moveToTradePointView">
                                <font-awesome-icon icon="info"/>
                            </div>

                            <div class="wrapper-circle-icon" @click="showCommentModal">
                                <font-awesome-icon icon="comment-alt"/>
                            </div>
                        </b-row>
                        
                        <b-row class="pointer h-end m-0 fs-20">

                            <div v-if="entity.TradePoint &&
                                        ((entity.TradePoint.RecommendationList && entity.TradePoint.RecommendationList.length)
                                        || (entity.TradePoint.RecommendationTaskList && entity.TradePoint.RecommendationTaskList.length))"
                                 class="wrapper-circle-icon"
                                 @click="showRecommendationsModal">
                                <font-awesome-icon icon="envelope"/>
                            </div>

                            <div v-if="entity.TradePoint && entity.TradePoint.Segment" 
                                 class="wrapper-circle-icon bold fs-15"
                                 @click="isShowMML = true">
                                MML
                            </div>

                            <div class="wrapper-circle-icon" @click="openGallery">
                                <font-awesome-icon icon="camera"/>
                            </div>
                        </b-row>

                    </b-col>

                </b-row>              

            </b-container>
        </div>
        
        <b-img v-if="entity.TradePoint && entity.TradePoint.Segment"
               :src="entity.TradePoint.Segment.ImageUrl"
               :class="isShowMML ? 'mml-show' : 'mml-hide'"
               @click="isShowMML = false" />

        <div class="navigation">
            <b-container class="p-0-30">
                <b-nav>

                    <b-nav-item v-if="!entity.IsShortCall && entity.TradePoint"
                                id="form-nav-tasks" 
                                class="form-nav"
                                :active="setActiveNavItem(0)"
                                :style="!entity.IsMagnitQuestionsAnswered && entity.isExistsMagnitQuestions() ? 'pointer-events: none' : ''"
                                @click="clickNavItem('ЗАДАЧИ')">
                        Задачи
                    </b-nav-item>

                    <b-nav-item id="form-nav-questions"
                                class="form-nav"                                
                                :active="setActiveNavItem(1)"
                                :style="!entity.IsMagnitQuestionsAnswered && entity.isExistsMagnitQuestions() ? 'pointer-events: none' : ''" 
                                @click="clickNavItem('ВОПРОСЫ')">
                        Вопросы
                    </b-nav-item>

                    <b-nav-item v-if="entity.isExistsMagnitQuestions()"  
                                id="form-nav-magnit"
                                class="form-nav"
                                :active="setActiveNavItem(2)"
                                @click="clickNavItem('МАГНИТ')">
                        Магнит
                    </b-nav-item>

                </b-nav>
            </b-container>
        </div>
        
        <!-- ------------ЗАДАЧИ------------ -->

        <b-container v-if="activeNavItem == 0" class="m-20-auto">


            <b-list-group-item button
                               v-for="(item, index) in entity.TradePoint.TodoList" 
                               :key="index"
                               class="task"
                               :class="item.IsActive ? 'active-task' : ''"
                               @click="entity.showTask(item)">

                <task-item :item="item"/>

            </b-list-group-item> 

            <b-img src="/img/btn-plus.png" 
                   class="button-plus"
                   @click="addTask"/>

        </b-container>

        <!-- ------------ВОПРОСЫ------------ -->

        <b-container v-if="activeNavItem == 1" class="m-20-auto">
            <b-list-group>

                <b-list-group-item button
                                class="question" 
                                v-for="(item, index) in entity.QuestionList"
                                :key="index"
                                @click="openAnswer(item)">

                    <question-item :item="item" :index="index" />

                </b-list-group-item>

                <b-list-group-item v-if="(entity.IsCanFinish && entity.Status.Id == 1) || 
                                         (entity.IsShortCall && entity.Status.Id == 2)"
                                   class="container-button">

                    <b-button v-if="entity.IsCanFinish && entity.Status.Id == 1"
                              variant="outline-primary" 
                              class="button-blue"
                              @click="completeForm">
                        Завершить
                    </b-button>

                    <b-button v-if="entity.IsShortCall && entity.Status.Id == 2"
                              variant="outline-primary" 
                              class="button-blue"
                              @click="completeAudit">
                        Отправить
                    </b-button>

                </b-list-group-item>

            </b-list-group>
        </b-container>

        <!-- ------------МАГНИТ------------ -->

        <b-container v-if="activeNavItem == 2" class="m-20-auto">
            <b-list-group>

                <b-list-group-item button
                                class="question" 
                                v-for="(item, index) in entity.MagnitQuestionList"
                                :key="index"
                                @click="openAnswer(item)">

                    <question-item :item="item" :index="index"/>

                </b-list-group-item>

                <b-list-group-item v-if="entity.IsNeedSaveMagnit" class="main-input-nav h-end" >

                    <b-button variant="outline-primary" 
                              class="button-blue"
                              @click="completeFormMagnitDialog">
                        Сохранить ответы Магнита
                    </b-button>
                    
                </b-list-group-item>

            </b-list-group>

        </b-container>

        <input-modal v-model="entity.Comment" 
                     :is-edit="entity.Status.Id == 1"
                     placeholder="Комментарий к форме"
                     @save="updateComment"/>
        
        <recommendations-modal :recommendation-list="entity.TradePoint ? entity.TradePoint.RecommendationList : []"
                               :recommendation-task-list="entity.TradePoint ? entity.TradePoint.RecommendationTaskList : []" />

    </div>
	
</template>

<script>
import '@/assets/styles/client/form/form.css'

import AllRoutes from '@/routes/all.routes'
import apiService from'@/services/api.service'

import Consts from '@/store/models/consts/clientConsts'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import QuestionItem from '@/components/client/form/QuestionItem'
import TaskItem from '@/components/client/form/TaskItem'
import InputModal from '@/components/shared/InputModal'
import RecommendationsModal from '@/components/client/tradePoints/RecommendationsModal.vue'

import FormModel from '@/store/models/client/form/Form'

import dialogService from '@/services/dialog.service'

export default {
    beforeRouteEnter: function(to, from, next) {
        next(vm => {
            vm.isFromTTView = from.path === AllRoutes.Client.TradePoints.View && from.query.isEdit === undefined;
        })
    },
    data: function() {
        let load = new Loading();
        this.getForm(load);

        return {
            load: load,
            entity: null,
            activeNavItem: null,

            auditId: this.$route.query.auditId,
            isShowMML: false,

            isFromTTView: false
        };
    },
    methods: {
        getForm: function(load) {
            load.Calculate(true);

            apiService.Client.Form.Get(this.$route.query.auditId, this.$route.query.id)
                .then(response => {
                    this.entity = new FormModel().mapFromDto(response.data);                    
                    this.activeNavItem = !this.entity.IsMagnitQuestionsAnswered && this.entity.isExistsMagnitQuestions() ? 2 : 1;
                    
                    if(this.entity.isExistsMagnitQuestions() && !this.entity.IsMagnitQuestionsAnswered)
                        dialogService.showAlert('Сообщение', 'Поступил сигнал по нескольким SKY из AEP! В начале визита необходимо проверить, есть ли товар на полке и ответить на вопрос: Товар отсутствует на полке? (ответ "Да" - отсутствует, ответ "Нет" - присутствует)');

                    if(this.entity.TradePoint && this.entity.TradePoint.Segment) {
                        let image = new Image();
                        image.src = this.entity.TradePoint.Segment.ImageUrl;

                        let width = image.width / 6.6;
                        let height = image.height / 6.6;

                        this.modalWidth = Math.ceil(width);
                        this.modalHeight = Math.ceil(height);
                    }

                    load.Calculate(false);

                    if (this.entity.TradePoint.Tma && this.isFromTTView) {
                        let tma = this.entity.TradePoint.Tma;
                        dialogService.showAlert('В ТТ есть ТМА!', 
                            `(${tma.TmaDaxId}) ${tma.Name} <br />` +
                            `Механика: ${tma.Mechanic} <br />` +
                            `Скидка для конечного покупателя: ${tma.Discount}% <br />` +
                            `Дата начала: ${this.getDateString(new Date(tma.StartDate))} <br />` +
                            `Дата окончания: ${this.getDateString(new Date(tma.EndDate))}`);
                    }
                    else if ((this.entity.TradePoint.RecommendationList && this.entity.TradePoint.RecommendationList.length)
                                || (this.entity.TradePoint.RecommendationTaskList && this.entity.TradePoint.RecommendationTaskList.length)) {
                        setTimeout(this.showRecommendationsModal, 200);
                    }
                })
                .catch(() => load.Calculate(false));
        },

        setActiveNavItem: function(item) {
            return this.activeNavItem == item;
        },
        clickNavItem: function(name) {
            if(!this.entity.IsMagnitQuestionsAnswered && this.entity.isExistsMagnitQuestions()) {
                dialogService.showAlert( 'Внимание!', `Вы не можете перейти на вкладку ${name} пока не ответите на все вопросы блока Магнит`);
                return;
            }  

            this.activeNavItem = name == 'ЗАДАЧИ'
                                    ? 0 : name == 'ВОПРОСЫ'
                                        ? 1 : 2;
        },

        completeForm: function() {
           this.load.Calculate(true);
           
            apiService.Client.Form.PostComplete(this.auditId, this.entity.Id)
                .then(() => {
                    if (!this.entity.IsShortCall)
                        this.$router.push(AllRoutes.Client.Audit.Index + `?id=${this.auditId}`);
                    else
                        this.$router.go(this.$router.currentRoute);
                })
                .catch(() => this.load.Calculate(false));
        },

        completeAudit: function() {
            this.load.Calculate(true);

            apiService.Client.Audit.PostComplete(this.auditId)
                .then(() => {
                    this.load.Calculate(false);
                    this.sendAudit();
                })
                .catch(() => this.load.Calculate(false));
        },
        sendAudit: function() {
            this.load.Calculate(true);

            apiService.Client.Auidt.PostSend(this.auditId)
                .then(() => this.$router.push(AllRoutes.Client.Feed))
                .catch(() => this.load.Calculate(false));
        },

        completeFormMagnitDialog: function() {
            dialogService.showConfirm( 'Подтверждение сохранения', 'Подтвердите сохранение ответов на вопросы Магнита. Внимание! После этого нельзя изменять ответы во вкладке МАГНИТ.')
                .then(() => {
                    this.completeFormMagnit();
                });
        },
        completeFormMagnit: function() {
            apiService.Client.Form.PostConfirmMagnit(this.auditId, this.entity.Id)
                .then(() => {
                    this.entity.IsMagnitQuestionsAnswered = true;
                    this.entity.IsNeedSaveMagnit = false;
                });
        },

        addTask: function() {
            this.$router.push(AllRoutes.Client.Form.CreateTask + `?tradePointId=${this.entity.TradePoint.Id}&formId=${this.entity.Id}&auditId=${this.auditId}`)
        },

        openAnswer: function(question) {
           if((this.entity.Name == "Начало аудита") || ((this.entity.Name == "Конец аудита"))) {
            this.$router.push({ path: AllRoutes.Client.Form.Answer + `?auditId=${this.auditId}&formId=${this.entity.Id}&questionId=${question.Id}`, 
                                query: { showTaskButton: false }})
           } else {
                    this.$router.push({ path: AllRoutes.Client.Form.Answer + `?auditId=${this.auditId}&formId=${this.entity.Id}&questionId=${question.Id}`, 
                                query: { showTaskButton: true }})
            }

             
        },

        openGallery: function() {
            this.$router.push(AllRoutes.Client.Gallery.Index + `?auditId=${this.auditId}&formId=${this.entity.Id}`)
        },

        showRecommendationsModal() {
            this.$modal.show('recommendations-modal');
        },

        showCommentModal: function() {
            this.$modal.show('input-modal');
        },

        updateComment: function(text) {
            let commentDto = {
                AuditId: this.auditId,
                FormId: this.entity.Id,
                Comment: text
            };

            this.load.Calculate(true);

            apiService.Client.Form.PostUpdateComment(commentDto)
                .then(() => {
                    this.$router.go(this.$router.currentRoute);
                })
                .catch(() => this.load.Calculate(false));
        },

        moveToTradePointView: function() {
            this.$router.push({
                name: AllRoutes.Client.TradePoints.View,
                params: { tradePoint: this.entity.TradePoint },
                query: { auditId: this.auditId, isEdit: false }
            });
        },

        getDateString: function(value) {
            return `${value.getDate()} ${Consts.months.find(e => e.Id == value.getMonth()).Text} ${value.getFullYear()}`;
        }
    },
    components: {
        Spinner,
        QuestionItem,
        TaskItem,
        InputModal,
        RecommendationsModal
    }
}
</script>